
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Drawer from 'vux/src/components/drawer/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Panel from 'vux/src/components/panel/index.vue'

import { list, logout, resetPassword, update, login } from "../../comon/api/home";
import axios from "axios";
export default {
directives: {
TransferDom
},
name: "MobileHome",
created() {
this._getList();
this.ruleForm = JSON.parse(localStorage.getItem("userInfos"));
if (JSON.parse(localStorage.getItem("userInfos")).resetPasswd == 0) {
this.centerDialogVisibles = true;
}
},
watch: {
password: function (val, oldVal) {
this.ruleForm.password = val;
}
},
components: {
XButton,
FlexboxItem,
Flexbox,
Confirm,
XInput,
Drawer,
Cell,
XHeader,
Panel
},
data() {
return {
isResetpwd: false,
drawerVisibility: false,
ruleForm: {},
password: "",
checkPwd: "",
list: [],
total: 0,
value1: "",
value2: "",
value3: "",
value4: "",
show: false,
centerDialogVisibles: false,
obj: JSON.parse(localStorage.getItem("userInfos"))
};
},
methods: {
onHide1() { },
onShow1() { },
onConfirm1() {
this.centerDialogVisibles = true;
if (this.value3 == "") {
this.$vux.toast.text("请输入新密码...", "middle");
this.centerDialogVisibles = true;
} else if (this.value4 == "") {
this.$vux.toast.text("请输入确认新密码...", "middle");
this.centerDialogVisibles = true;
} else if (this.value3 != this.value4) {
this.$vux.toast.text("两次输入的密码不一致...", "middle");
this.value3 = "";
this.value4 = "";
this.centerDialogVisibles = true;
} else {
this.centerDialogVisibles = true;
resetPassword({
username: this.obj.username,
password: this.value3,
id: this.obj.id
})
.then(res => {
if (res.code == 200) {
this._login(this.obj.username, this.value3);
this.value3 = "";
this.value4 = "";
this.centerDialogVisibles = false;
this.$vux.toast.text(`重置密码成功`, "middle");
} else {
this.$vux.toast.text(`${res.msg}`, "middle");
}
})
.catch(err => {
console.log(err);
});
}
},
onCancel1() { },
onHide() { },
onShow() { },
resetCheked() {
if (this.isResetpwd && this.password == "") {
this.$vux.toast.text("请输入密码...", "middle");
return false;
} else if (this.isResetpwd && this.checkPwd == "") {
this.$vux.toast.text("请确认密码...", "middle");
return false;
} else if (this.isResetpwd && this.password != this.checkPwd) {
this.$vux.toast.text("两次输入的密码不一致...", "middle");
this.password = "";
this.checkPwd = "";
return false;
} else {
return true;
}
},
onConfirm() {
if (this.resetCheked()) {
update({
id: this.ruleForm.id,
userId: this.ruleForm.userId,
username: this.ruleForm.username,
password: this.ruleForm.password,
phone: this.ruleForm.phone,
email: this.ruleForm.email,
menuId: this.ruleForm.menuId,
orgId: this.ruleForm.orgId
})
.then(res => {
if (res.code == 200) {
this.isResetpwd = false;
this.$vux.toast.text(`修改成功`, "middle");
localStorage.setItem("userInfos", JSON.stringify(this.ruleForm));
this.show = false;
} else {
this.$vux.toast.text(`${res.msg}`, "middle");
}
})
.catch(err => {
console.log(err);
});
}
},
onCancel() {
setTimeout(() => {
this.isResetpwd = false;
}, 600);
},
fixedPaaword() {
this.show = true;
},
logout() {
axios
.get(`/logout/${localStorage.getItem("sessionId")}`)
.then(res => {
if (res.data.code == 200) {
localStorage.removeItem("sessionId");
localStorage.removeItem("session_mobile");
this.$router.push({
path: "/mobile_login"
});
}
})
.catch(err => {
console.log(err);
});
},
_login(userName, password) {
login({
username: userName,
password: password
}).then(res => {
if (res.code == 200) {
localStorage.setItem('sessionId', res.data.sessionId)
localStorage.setItem('session_pc', res.data.sessionId)
localStorage.setItem('userInfo', res.data.userInfo.menuId)
localStorage.setItem('userInfos', JSON.stringify(res.data.userInfo))
}
}).catch(err => {
console.log(err)
})
},
_getList() {
list({
username: JSON.parse(localStorage.getItem("userInfos")).username,
orgId: JSON.parse(localStorage.getItem("userInfos")).orgId
})
.then(res => {
if (res.code == 200) {
let data = localStorage.getItem("userInfo");
let arr = data.split(",");
res.data.forEach(element => {
for (let i = 0; i < arr.length; i++) {
if (element.menuId == arr[i] && element.menuPlatform === 1) {

this.list.push(element);

}
}
});
this.total = 4 - (this.list.length % 4);
}
})
.catch(err => {
console.log(err);
});
},
jumpToDeail(item) {
if (item.menuName == "账户管理") {
this.$router.push({
path: "/list"
});
} else if (item.menuName == "OA系统") {
let seesionId = localStorage.getItem("sessionId");




window.location.href = `${item.loginUrl}?platform=h5&session_id=` + seesionId
} else {
let seesionId = localStorage.getItem("sessionId");

window.location.href = `${item.loginUrl}?session_id=` + seesionId
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/mobile/Home.vue